

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_8ailheakad = () => {
                    
                        if (document.querySelector('.beae-udn2pmgv:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-udn2pmgv:not([data-beae-bind])'),
                                
                                id: 'beae-udn2pmgv',
                                isLive: true
                            });
                            document.querySelector('.beae-udn2pmgv:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-u3cjiue7:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-u3cjiue7:not([data-beae-bind])'),
                                
                                id: 'beae-u3cjiue7',
                                isLive: true
                            });
                            document.querySelector('.beae-u3cjiue7:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_8ailheakad()
                } else {
                    window.beaePageJS.push(jsHandle_8ailheakad)
                }
            